<template>
<div>
  <div class="image-edits">
    <image-edit :imageUrl="profilePictureUrl"
      :title="this.$t('profile.changeAvatar')" class="image-edit"
      v-on:change="changeProfilePicture"
      :loading="uploadingProfilePicture" />
    <image-edit :imageUrl="coverPictureIconUrl"
      :title="this.$t('profile.changeCover')" class="image-edit"
      :loading="uploadingCoverPicture"
      v-on:change="changeCoverPicture" />
  </div>
  <hirer-form class="profile-form" />
</div>
</template>

<script>
import SidebarModal from '@/components/sidebar-modal'
import ImageEdit from '@/components/profile/image-edit'
import { mapGetters, mapActions } from 'vuex'
import HirerForm from '@/components/signup/hirer-form'

export default {
  components: { ImageEdit, SidebarModal, HirerForm },
  computed: {
    ...mapGetters('users', [
      'profilePictureUrl',
      'coverPictureIconUrl',
      'user'
    ])
  },
  data () {
    return {
      uploadingProfilePicture: false,
      uploadingCoverPicture: false
    }
  },
  async mounted () {
    // await this.getUser()
    const user = this.user
    this.loadWithUser({user, profile: 'hirer'})
  },
  methods: {
    ...mapActions('users', [
      'getUser',
      'uploadProfileImage',
      'uploadCoverImage'
    ]),
    ...mapActions('hirerProfileForm', [
      'loadWithUser'
    ]),
    closeSidebar () {
      this.$emit('close')
    },
    async changeProfilePicture (file) {
      this.uploadingProfilePicture = true
      await this.uploadProfileImage(file)
      console.log('here we are')
      window.setTimeout(() => {
        this.uploadingProfilePicture = false
      }, 1000)
    },
    async changeCoverPicture (file) {
      this.uploadingCoverPicture = true
      await this.uploadCoverImage(file)
      window.setTimeout(() => {
        this.uploadingCoverPicture = false
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
.image-edits {
  margin-top: 8px;
  display: flex;
  justify-content: space-around;
}
.profile-form {
  margin-top: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/hirer/hirer-edit-profile.vue